import { parse } from 'yaml'
import { SIGHTMAP_DOC, type SightmapComponent } from '../guidance/polish/sightmap/schema'
import type { AppArtifactBundle } from '../guidance/app-tools/artifact-schema'

const SightmapFileSchema = SIGHTMAP_DOC.extend({ views: SIGHTMAP_DOC.shape.views.default([]) })

export function toolTargetDetails(bundle: AppArtifactBundle | undefined, surfaceId?: string, controlId?: string) {
  if (!controlId) return null
  function find(components: SightmapComponent[] | undefined, parents: SightmapComponent[] = []): SightmapComponent[] | null {
    for (const component of components ?? []) {
      if (component.id === controlId) return [...parents, component]
      const nested = find(component.children, [...parents, component])
      if (nested) return nested
    }
    return null
  }
  for (const file of bundle?.files ?? []) {
    if (!file.path.startsWith('.sightmap/') || !file.path.endsWith('.yaml')) continue
    try {
      const parsed = SightmapFileSchema.safeParse(parse(file.contents))
      if (!parsed.success) continue
      for (const view of parsed.data.views) {
        if (surfaceId && view.id !== surfaceId) continue
        const path = find(view.components)
        if (path) return { surface: view.name, path }
      }
      const path = find(parsed.data.components)
      if (path) return { surface: null, path }
    } catch { /* Missing or malformed historical map: show the saved reference instead. */ }
  }
  return null
}
